import * as fdc3 from 'openfin-fdc3';
import {injectable, inject} from 'inversify';

import {Inject} from '../common/Injectables';
import {ServiceStore} from '../store/ServiceStore';
import {Action} from '../store/Store';
import {EngineAction} from '../model/Search';
import {RootState} from '../store/State';
import {PostLogin} from '../store/partials/Authentication';
import {ExecuteEngineAction, GetSearchEngines} from '../store/partials/SearchEngines';

import {AsyncInit} from './AsyncInit';

@injectable()
export class SearchEngines extends AsyncInit {
    public constructor(@inject(Inject.STORE) private readonly store: ServiceStore) {
        super();
        this.store.onAction.add(this.onAction, this);
    }

    protected async init() {
        await this.store.initialized;
    }

    private async onAction(action: Action<RootState>): Promise<void> {
        if (action instanceof PostLogin) {
            await this.store.dispatch(new GetSearchEngines());
        } else if (action instanceof ExecuteEngineAction) {
            await this.executeEngineAction(action.action);
        }
    }

    private async executeEngineAction(action: EngineAction): Promise<void> {
        if (action.type === 'application') {
            await fin.Application.startFromManifest(action.manifestUrl);
        } else if (action.type === 'browser') {
            await fin.System.openUrlWithBrowser(action.url);
        } else if (action.type === 'intent') {
            await fdc3.raiseIntent(action.intent, action.context, action.target);
        }
    }
}
